<template>
  <div class="container">
    <div class="main">
      <div class="title" >SuperGT Rd3马来西亚站GAINER DIXCEL SLS获得季军 </div>
      <div style="color :gray;font-size :14px;text-align:center;margin-bottom:20px">2013-6-17</div>
      <div style="line-height:30px">
        <div style="text-indent:30px">  6月16日在马来西亚举行的SGT第3回合比赛中，GT300的GAINER DIXCEL SLS勇夺季军。另一辆GAINER Rn-SPORTS DIXCEL SLS也获得了第7，拿到了宝贵的积分。GAINER DIXCEL SLS与GAINER Rn-SPORTS DIXCEL SLS都使用DIXCEL最高竞技用刹车皮【Specom 阿尔法】进行比赛。</div>    
        <div style="text-indent:30px;"> 【Specom 阿尔法】介绍专页：
          <a href="http://www.dixcel.cn/productshow.asp?id=37">http://www.dixcel.cn/productshow.asp?id=37</a>
        </div>
      </div>

      <div style="width:70%;margin:0 auto;margin-bottom:20px">
        <el-image
          style="width:100%;margin-bottom:20px"
          :src="require('@/assets/image/moment/newsActivitiesPage/2013_06_17/img1.png')"
          fit="fit">
        </el-image>
      </div>

      <div style="line-height:30px">

        <el-table
          :data="tableData"
          style="width: 100%">
          <el-table-column
            prop="Po"
            label=""
            >
          </el-table-column>
          <el-table-column
            prop="No"
            label=""
          >
          </el-table-column>
          <el-table-column
            prop="Machine"
            label=""
            width='180'
            >
          </el-table-column>
          <el-table-column
            prop="Driver"
            label=""
            width='200'>
          </el-table-column>
          <el-table-column
            prop="Time"
            label="">
          </el-table-column>
          <el-table-column
            prop="Laps"
            label="">
          </el-table-column>
          <el-table-column
            prop="BestLap"
            label="">
          </el-table-column>
          <el-table-column
            prop="Tire"
            label="">
          </el-table-column>

        </el-table>
      </div>

    </div>
  </div>
</template>


<script>
    export default {
      data() {
        return { 

          
          tableData: [{
            Po :  1 ,
            No :	55 ,
            Machine :  'ARTA CR-Z GT'	 ,
            Driver : 	'高木真一 小林崇志' ,
            Time : 	"BS" ,
            Laps:	51 ,
            BestLap: "1" ,	 
            Tire:	" 2'03`025 " ,
          },{
            Po :  2 ,
            No :	16 ,
            Machine :  'MUGEN CR-Z GT'	 ,
            Driver : 	'武藤英紀 中山友貴' ,
            Time : 	"BS" ,
            Laps:	51 ,
            BestLap: "2" ,	 
            Tire:	" 2'03`374 " ,
          },{
            Po :  3 ,
            No :	11 ,
            Machine :  'GAINER DIXCEL SLS'	 ,
            Driver : 	'平中克幸 B.ビルドハイム' ,
            Time : 	"DL" ,
            Laps:	51 ,
            BestLap: "7" ,	 
            Tire:	" 2'04`682 " ,
          },{
            Po :  4 ,
            No :	61 ,
            Machine :  'SUBARU BRZ R&D SPORT'	 ,
            Driver : 	'山野哲也 佐々木孝太' ,
            Time : 	"MI" ,
            Laps:	51 ,
            BestLap: "3" ,	 
            Tire:	" 2'03`850 " ,
          },{
            Po :  5 ,
            No :	88 ,
            Machine :  'マネパ ランボルギーニ GT3'	 ,
            Driver : 	'織戸学 青木孝行' ,
            Time : 	"YH" ,
            Laps:	51 ,
            BestLap: "5" ,	 
            Tire:	" 2'04`137 " ,
          },{
            Po :  6 ,
            No :	4 ,
            Machine :  'GSR初音ミクBMW'	 ,
            Driver : 	'谷口信輝 片岡龍也' ,
            Time : 	"YH" ,
            Laps:	51 ,
            BestLap: "16" ,	 
            Tire:	" 2'05`625 " ,
          },{
            Po :  7 ,
            No :	10 ,
            Machine :  'GAINER Rn-SPORTS DIXCEL SLS'	 ,
            Driver : 	'田中哲也 植田正幸' ,
            Time : 	"DL" ,
            Laps:	51 ,
            BestLap: "10" ,	 
            Tire:	" 2'05`606 " ,
          },{
            Po :  8 ,
            No :	62 ,
            Machine :  'LEON SLS'	 ,
            Driver : 	'黒澤治樹 黒澤翼' ,
            Time : 	"YH" ,
            Laps:	51 ,
            BestLap: "15" ,	 
            Tire:	" 2'05`601  " ,
          },{
            Po :  9 ,
            No :	86 ,
            Machine :  'クリスタルクロコ ランボルギーニ GT3'	 ,
            Driver : 	'山西康司 細川慎弥' ,
            Time : 	"YH" ,
            Laps:	51 ,
            BestLap: "9" ,	 
            Tire:	" 2'05`342  " ,
          },{
            Po :  10 ,
            No :	3 ,
            Machine :  'S Road NDDP GT-R'	 ,
            Driver : 	'星野一樹 佐々木大樹' ,
            Time : 	"YH" ,
            Laps:	50 ,
            BestLap: "17" ,	 
            Tire:	" 2'05`639  " ,
          },{
            Po :  11 ,
            No :	0 ,
            Machine :  'ENDLESS TAISAN PORSCHE'	 ,
            Driver : 	'峰尾恭輔 横溝直輝' ,
            Time : 	"YH" ,
            Laps:	50 ,
            BestLap: "4" ,	 
            Tire:	" 2'03`901  " ,
          },{
            Po :  12 ,
            No :	52 ,
            Machine :  'OKINAWA-IMP SLS	'	 ,
            Driver : 	'竹内浩典 土屋武士' ,
            Time : 	"YH" ,
            Laps:	50 ,
            BestLap: "6" ,	 
            Tire:	" 2'04`450  " ,
          },{
            Po :  13 ,
            No :	48 ,
            Machine :  'DIJON Racing IS GT-R	'	 ,
            Driver : 	'高森博士 千代勝正' ,
            Time : 	"YH" ,
            Laps:	50 ,
            BestLap: "13" ,	 
            Tire:	" 2'08`124  " ,
          },{
            Po :  14 ,
            No :	21 ,
            Machine :  'ZENT Audi R8 LMS ultra'	 ,
            Driver : 	'都筑晶裕 R.ライアン' ,
            Time : 	"HK" ,
            Laps:	50 ,
            BestLap: "23" ,	 
            Tire:	" No Time  " ,
          },{
            Po :  15 ,
            No :	2 ,
            Machine :  'エヴァRT初号機アップルMP4-12C'	 ,
            Driver : 	'高橋一穂 加藤寛規' ,
            Time : 	"YH" ,
            Laps:	50 ,
            BestLap: "12" ,	 
            Tire:	" 2'08`092 " ,
          },{
            Po :  16 ,
            No :	5 ,
            Machine :  'マッハGoGoGo車検Ferrari458'	 ,
            Driver : 	'玉中哲二 山下潤一郎' ,
            Time : 	"YH" ,
            Laps:	49 ,
            BestLap: "20" ,	 
            Tire:	" 2'06`943 " ,
          },{
            Po :  17 ,
            No :	30 ,
            Machine :  'IWASAKI apr R8'	 ,
            Driver : 	'岩崎祐貴 I.スシュコ' ,
            Time : 	"YH" ,
            Laps:	49 ,
            BestLap: "22" ,	 
            Tire:	" 2'10`043 " ,
          },{
            Po :  18 ,
            No :	9 ,
            Machine :  'NAC攻殻機動隊ARIS DR PORSCHE'	 ,
            Driver : 	'密山祥吾 茂田久男' ,
            Time : 	"YH" ,
            Laps:	49 ,
            BestLap: "19" ,	 
            Tire:	" 2'06`807 " ,
          },{
            Po :  19 ,
            No :	360 ,
            Machine :  'RUN UP GROUP GT-R'	 ,
            Driver : 	'白坂卓也 田中篤' ,
            Time : 	"YH" ,
            Laps:	49 ,
            BestLap: "21" ,	 
            Tire:	" 2'08`662 " ,
          },{
            Po :  20 ,
            No :	50 ,
            Machine :  'Exe Aston Martin'	 ,
            Driver : 	'加納政樹 安岡秀徒' ,
            Time : 	"YH" ,
            Laps:	48 ,
            BestLap: "24" ,	 
            Tire:	" No Time " ,
          },{
            Po :  "R" ,
            No :	87 ,
            Machine :  'ラ・セーヌ ランボルギーニ GT3'	 ,
            Driver : 	'山内英輝 吉本大樹' ,
            Time : 	"YH" ,
            Laps:	26 ,
            BestLap: "11" ,	 
            Tire:	" 2'05`903 " ,
          },{
            Po :  "R" ,
            No :	33 ,
            Machine :  'HANKOOK PORSCHE'	 ,
            Driver : 	'影山正美 藤井誠暢' ,
            Time : 	"HK" ,
            Laps:	25 ,
            BestLap: "8" ,	 
            Tire:	" 2'05`327 " ,
          },{
            Po :  "R" ,
            No :	22 ,
            Machine :  'グリーンテック SLS AMG GT3'	 ,
            Driver : 	'和田久 城内政樹' ,
            Time : 	"YH" ,
            Laps:	23 ,
            BestLap: "18" ,	 
            Tire:	" 2'06`349 " ,
          },{
            Po :  "R" ,
            No :	31 ,
            Machine :  'Panasonic apr PRIUS GT'	 ,
            Driver : 	'新田守男 嵯峨宏紀' ,
            Time : 	"YH" ,
            Laps:	7 ,
            BestLap: "14" ,	 
            Tire:	" 2'05`470 " ,
          }]
																																										
       																																																																																																	  							
          														
        }
      }
    }
  </script>

<style lang="stylus" scoped>


.container
  background-color : #000
  .box_one 
    width: 100%;

  .box_bottom
    width: 100%;
    background-color #000


.main {
  margin-bottom: 5px;
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  padding: 62px 50px 52px;
}
  .title {
    color :#ab191d;
    text-align:center;
    margin-bottom 10px
  }


</style>